export const containerClassName =
   'flex flex-col justify-start items-start  w-[280px]  h-screen  border-r-default'
